/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service imports.
 */
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from 'src/app/constants/app.constants';
import { FunCollectionService } from 'src/app/common/common-functions/fun-collection.service';

/**
 * Drug Sample Card Component.
 */
@Component({
  selector: 'app-drug-sample-card',
  templateUrl: './drug-sample-card.component.html',
  styleUrls: ['./drug-sample-card.component.scss']
})
export class DrugSampleCardComponent implements OnInit, OnDestroy {
  @Input() callingfrom;
  @Input() drugListObj;
  @Input() is_ordered;
  @Input() type;

  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    private router: Router,
    private masterService: MasterserviceService,
    public dss: DataStorageService,
    private analyticSdk: Analytics,
    public fcs: FunCollectionService,
    public mls: NewLanguageService) {

  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {

    this.subscriptions.add(this.dss.drugOrderFinished.subscribe(data => {
      //  console.log(data);
      if (this.drugListObj.drug_id == data.drug_id) {
        this.is_ordered = 1;
      }

    }));

  }

  /**
   * navigate To Detail
   */
  navigateToDetail(drug_id): boolean {

    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.DRUG_SAMPLE,drug_id,this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK,ACTION_ON.DRUG, null);
    this.router.navigateByUrl('pharma/drug/' + drug_id);
  }

  /**
   * show event session modal
   */
  showDrugForm(eventSession): boolean {

    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.displayObj.isShow = true;
    this.displayObj.display_section = 'showDrugForm';
    this.displayObj.data = [{ data: eventSession }];
    this.masterService.showWebModal.next(this.displayObj);
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.DRUG_SAMPLE,this.drugListObj?.drug_id ,SCREEN_NAME.DRUG_LIST, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK,ACTION_ON.REQUEST_DRUG_SAMPLE, null);
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
